import { FC } from 'react'

export interface HighlightMatchesProps {
  children: string
  search: string
  className?: string
}

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export const HighlightMatches: FC<HighlightMatchesProps> = ({
  children: input,
  search,
  className,
}) => {
  if (!search) {
    return <>{input}</>
  }

  const escapedSearch = escapeRegExp(search)
  const regex = new RegExp(`(${escapedSearch})`, 'gi')
  const parts = input.split(regex)

  return (
    <>
      {parts.map((part, index) =>
        part.toLowerCase() === search.toLowerCase() ? (
          <span key={index} className={className}>
            {part}
          </span>
        ) : (
          part
        )
      )}
    </>
  )
}
